export default {
  enabled: {
    value: false,
    required: false,
    state: null
  },
  domain: {
    value: '',
    required: true,
    state: null,
    maxlength: 100
  },
  socketUrl: {
    value: 'wss://new-socket.3c.plus',
    required: true,
    state: null,
    maxlength: 200
  },
  connectionTimeout: {
    value: 15000,
    required: false,
    state: null,
    maxlength: 10
  },
  iframeTimeout: {
    value: 10000,
    required: false,
    state: null,
    maxlength: 10
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros/threeCPlus/threeCPlus-form.js